<app-spinner id="spinner" [loading]="spinnerService.loading$ | async" />
<form [formGroup]="initialForm" (ngSubmit)="onSubmit()">
  <div class="reddi-sub-menu-container">
    <app-sub-menu
      [clientId]="clientId"
      [totalReviews]="_totalReviews"
      [flipHasAccess]="_hasAccess.flipHasAccess"
      [reddiHasAccess]="_hasAccess.reddiHasAccess"
      [slatHasAccess]="_hasAccess.slatHasAccess"
      [showBackButton]="true"
      [showCancelDialog]="false"
      (navigateBackClick)="previousRoute()"
    />
    <app-action-toolbar
      [isEdit]="false"
      (editClick)="navigateTo('editReddi')"
      [isFullView]="false"
      (fullViewClick)="navigateTo('fullViewReddi')"
      [isHistory]="true"
      (historyClick)="navigateTo('historyReddi')"
      [isReport]="false"
      (reportClick)="navigateTo('reportReddi')"
      [isNew]="true"
      (newClick)="navigateTo('newReddi')"
      style="display: flex; justify-content: flex-end"
    />
  </div>
  <div class="external-report-heading reddi-report-form">
    <div class="header-text">
      {{ 'Progress Report Caption' | translate }}
    </div>
    <div class="logo">
      <img [src]="path" alt="REDDI logo" class="reddi-logo" />
    </div>
  </div>
  <div class="reddi-report-form">
    <strong>{{ 'Date' | translate }}:</strong>
    {{ _todayDate | date: 'dd/MM/yyyy' }}
  </div>
  <div class="reddi-report-form">
    <strong>{{ 'Name' | translate }}:</strong> {{ _clientName }}
    <strong>{{ 'Age' | translate }}:</strong> {{ _age }}
    <strong>{{ 'Date of Birth' | translate }}:</strong> {{ _dob }}
  </div>
  <div class="assessment-info reddi-report-form">
    <p>{{ _clientName }}'s {{ 'Reddi Report Caption' | translate }}</p>
  </div>
  <div>
    <div class="assessment-headline">{{ 'Select date range' | translate }}</div>
    <div class="reddi-report-form">
      <app-datepicker
        id="from-date"
        label="{{ 'Earliest date to display on graph' | translate }}"
        required="true"
        placeholder="{{ 'From Date (DD/MM/YYYY)' | translate }}"
        [control]="initialForm.controls['fromDate']"
        [errorText]="GetDateFromErrorText()"
      />
      <app-datepicker
        id="to-date"
        label="{{ 'Latest date to display on graph' | translate }}"
        required="true"
        placeholder="{{ 'To Date (DD/MM/YYYY)' | translate }}"
        [control]="initialForm.controls['toDate']"
        [errorText]="GetDateToErrorText()"
      />
    </div>
    <div class="assessment-headline">
      {{ 'Select listening condition to display on graph' | translate }}
    </div>
    <div
      *ngFor="let dropdown of dropdowns; let i = index"
      class="reddi-report-form"
    >
      <app-dropdown
        [control]="dropdown.control"
        [data]="dropdown.data"
        [label]="dropdown.label"
        [id]="'dropdown' + (i + 1)"
      >
      </app-dropdown>
    </div>
    <div class="reddi-report-form">
      <div class="title">
        <label for="clinicianName">{{ 'Comments' | translate }} </label>
        <textarea
          formControlName="comment"
          id="comment"
          class="reddi-report-comments"
          matInput
          placeholder="{{ 'Clinician comments Reddi' | translate }}"
        ></textarea>
      </div>
    </div>
    <div class="contact-info-footer">
      <div class="clinician-info">
        <div class="input-info">
          <label for="clinicianName"
            ><strong>{{ 'Clinician name' | translate }} * </strong></label
          >
          <input
            required
            matInput
            formControlName="clinicianName"
            id="clinicianName"
            type="text"
            placeholder="{{ 'Enter clinician name' | translate }}"
            class="text-input"
          />
        </div>
        <mat-error *ngIf="hasError('clinicianName', 'required')">
          {{ 'Clinician name is' | translate }}<strong>required</strong>
        </mat-error>

        <div class="input-info">
          <label for="title"
            ><p>
              <strong>{{ 'Title Role' | translate }}: * </strong>
            </p></label
          >
          <input
            required="true"
            matInput
            formControlName="title"
            id="title"
            type="text"
            placeholder="{{ 'Enter Role' | translate }}"
            class="text-input"
          />
        </div>
        <mat-error *ngIf="hasError('title', 'required')">
          {{ 'Title is' | translate
          }}<strong>{{ 'required' | translate }}</strong>
        </mat-error>
      </div>
      <div class="report-hearhub-logo">
        <app-hearhub-logo
          class="login-brand-logo"
          [inverted]="false"
        ></app-hearhub-logo>
      </div>
    </div>
    <div class="reddi-report-button">
      <button type="submit">{{ 'Generate report details' | translate }}</button>
    </div>
  </div>
</form>
